import type { CanalComunicacaoCertificado } from '@/features/arbitral-detalhes';
import type { SecaoDocumento } from '@/shared/components/documentos/paginado';

export const SECOES_CERTIFICADO_SENTENCA: readonly SecaoDocumento[] = [
  {
    numero: 1,
    titulo: 'Partes envolvidas',
    descricao: 'Requerente, requeridos e advogados do processo',
  },
  {
    numero: 2,
    titulo: 'Objetivo e escopo',
    descricao: 'O que é este documento e o que ele comprova',
  },
  {
    numero: 3,
    titulo: 'Situação da comprovação por parte',
    descricao: 'A quem a intimação foi entregue, por canal',
  },
  {
    numero: 4,
    titulo: 'Segurança do documento',
    descricao: 'Como os registros são protegidos contra adulteração',
  },
  {
    numero: 5,
    titulo: 'Detalhes de auditoria',
    descricao: 'Cada tentativa e evento, com data, hora e metadados',
  },
  {
    numero: 6,
    titulo: 'Comunicados enviados',
    descricao: 'Cópia íntegra da intimação enviada às partes',
  },
];

export const CANAIS_COMPROVACAO_SENTENCA: CanalComunicacaoCertificado[] = [
  'EMAIL',
  'WHATSAPP',
  'PLATAFORMA',
];

export const TITULO_CERTIFICADO_SENTENCA = 'Certificado de Acessos da Sentença';

export const TEXTOS_CERTIFICADO_SENTENCA = {
  eyebrowCapa: 'Processo Arbitral',
  objetivoTitulo: 'Qual é o objetivo da intimação?',
  // rn3: é a ENTREGA que permite avançar no encerramento, não a leitura. O texto anterior
  // ("com destaque para a confirmação de leitura") vinha da régua da citação e contrariava o
  // critério de aceite da história, que proíbe qualquer texto sugerindo a leitura como condição.
  eventosIntro:
    'Situação de cada parte por canal, com destaque para a comprovação de entrega. O registro cronológico completo, com metadados, está na seção de Detalhes de Auditoria.',
  auditoriaProvedores:
    'Para o envio das comunicações, utilizamos as plataformas Infobip, AWS, Azure da Microsoft e Meta, todas reconhecidas por sua alta confiabilidade no mercado. Essas plataformas possuem certificações de segurança ISO, assegurando que todos os dados transmitidos são protegidos e autênticos.',
  comunicadosIntro:
    'Cópia completa e autêntica da intimação enviada às partes, reproduzida com o visual exato do conteúdo enviado, com todos os destinatários e identificadores de cada envio.',
  comprovacaoColunaParte: 'Parte',
  vazioAuditoria: 'Nenhuma tentativa de comunicação registrada até a emissão deste certificado.',
  vazioAcessosPlataforma: 'Nenhum acesso à plataforma registrado até a emissão deste certificado.',
  vazioComunicados: 'Nenhuma cópia da intimação disponível até a emissão deste certificado.',
} as const;

export function textoOQueEDocumentoSentenca(numeroProcesso: string): string {
  return `Este certificado reúne todas as provas e registros de comunicação da intimação da sentença arbitral do processo nº ${numeroProcesso}. Ele comprova os envios, entregas e acessos das partes à comunicação da decisão.`;
}
